/**
 * Returns the effective "today" for game logic.
 * In dev mode:
 *   1) URL ?mockDate=YYYY-MM-DD overrides everything
 *   2) else VITE_MOCK_DATE from .env.emulator (e.g. a Tuesday for regular-status testing)
 * Time is set to 10:00 AM local so check-in window is typically open.
 */
function getMockDateString() {
  if (!import.meta.env.DEV || typeof window === 'undefined') return null
  const fromUrl = new URLSearchParams(window.location.search).get('mockDate')
  if (fromUrl) return fromUrl
  const fromEnv = import.meta.env.VITE_MOCK_DATE
  if (fromEnv && String(fromEnv).trim() !== '') return String(fromEnv).trim()
  return null
}

export function getEffectiveToday() {
  const mock = getMockDateString()
  if (mock) {
    const d = new Date(mock + 'T10:00:00')
    if (!isNaN(d.getTime())) return d
  }
  return new Date()
}

/** True when mockDate is active (for UI hints) */
export function isMockDateActive() {
  return getMockDateString() != null
}
